import React from "react";
import { FaShieldAlt } from "react-icons/fa";
import FormOne from "../contact/FormOne";

const BannerFive = () => {
  return (
    <div
      className="banner banner-style-5"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL + "/images/banner/banner-bg-1.jpg"})`, paddingBottom: 30,
      }}
    >
      <div className="container" >
        <div className="contact-form-box shadow-box" style={{ width: "100%" }}>
          <h3 className="title">Get A Free Quote and Schedule Your Appointment!</h3>
          <FormOne />
        </div>
      </div>
    </div>
  );
};

export default BannerFive;
